<template>
  <div :class="$style.wrapper">
    <section :class="$style.step">
      <h2 :class="$style.stepTitle">Шаг 1:</h2>
      <p :class="$style.stepDesc">
        Сохраните и отредактируйте Excel-шаблон, прикрепленный ниже
      </p>
      <a
        href="/files/example.xlsx"
        download="example.xlsx"
        target="_blank"
        rel="noopener noreferrer"
        :class="$style.downloadBtn"
        @click.prevent="handleDownload"
      >
        <span :class="$style.icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        Скачать Excel-шаблон
      </a>
    </section>

    <section :class="$style.step">
      <h2 :class="$style.stepTitle">Шаг 2:</h2>
      <p :class="$style.stepDesc">Загрузите заполненный Excel-шаблон</p>

      <div v-if="!file" :class="$style.uploadContainer">
        <button
          type="button"
          :class="$style.uploadBtn"
          @click="triggerFileInput"
        >
          <span :class="$style.icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          Загрузить каталог
        </button>
      </div>

      <div v-else :class="$style.filePreview">
        <div :class="$style.fileInfo">
          <span :class="$style.fileIcon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z"
                stroke="#111111"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13 2V9H20"
                stroke="#111111"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span :class="$style.fileName">{{ file.name }}</span>
        </div>
        <button type="button" :class="$style.removeBtn" @click="removeFile">
          <img
            src="@/assets/img/account/my-products/delete.svg"
            alt="Удалить"
          />
        </button>
      </div>

      <div v-if="uploadError" :class="$style.errorBox">
        <h3 :class="$style.errorTitle">Ошибка</h3>
        <p :class="$style.errorMessage">{{ uploadError }}</p>
      </div>

      <div
        v-if="importResult && importResult.skipped > 0"
        :class="$style.resultBox"
      >
        <h3 :class="$style.resultTitle">Импорт выполнен частично</h3>
        <p v-if="importSummary" :class="$style.resultSummary">
          {{ importSummary }}
        </p>
        <p :class="$style.resultSkipped">
          Пропущено {{ importResult.skipped }} — нет в каталоге:
        </p>
        <p
          v-if="importResult.skipped_articles && importResult.skipped_articles.length"
          :class="$style.resultArticles"
        >
          {{ importResult.skipped_articles.join(", ") }}
        </p>
        <p :class="$style.resultHint">
          Пропущенные артикулы можно добавить вручную — при добавлении товара
          выберите в списке моделей «Добавить свою модель».
        </p>
      </div>

      <input
        ref="fileInput"
        type="file"
        accept=".xlsx, .xls"
        :class="$style.hiddenInput"
        @change="handleFileChange"
      />
    </section>

    <div v-if="!hasTelegramMainButton" :class="$style.submitBar">
      <button
        type="button"
        :disabled="!file || isLoading"
        :class="$style.submitBtn"
        @click="handleUpload"
      >
        <span v-if="isLoading" :class="$style.spinner"></span>
        {{ isLoading ? "Загрузка..." : "Загрузить" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadExcel",
  data() {
    return {
      file: null,
      hasTelegramMainButton: false,
      mainButtonInstance: null,
      mbHandler: null,
      uploadError: null,
      importResult: null,
      isLoading: false,
    }
  },
  computed: {
    importSummary() {
      const d = this.importResult
      if (!d) return ""
      const parts = []
      if (d.created > 0) parts.push(`добавлено ${d.created}`)
      if (d.updated > 0) parts.push(`обновлено ${d.updated}`)
      // «удалено» убрано: импорт больше не удаляет отсутствующие строки
      return parts.length ? parts.join(" · ") : ""
    },
  },
  mounted() {
    this.setupMainButton()
  },
  beforeUnmount() {
    this.destroyMainButton()
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    handleDownload() {
      const fileUrl = window.location.origin + "/files/example.xlsx"
      const tg = window.Telegram?.WebApp

      if (tg?.openLink) {
        tg.openLink(fileUrl, { try_instant_view: false })
        return
      }

      const link = document.createElement("a")
      link.href = "/files/example.xlsx"
      link.download = "example.xlsx"
      link.target = "_blank"
      link.rel = "noopener noreferrer"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleFileChange(event) {
      const files = event.target.files
      if (files && files[0]) {
        this.file = files[0]
        // Сбрасываем ошибки и прошлый результат при выборе нового файла
        this.uploadError = null
        this.importResult = null
        // Не отправляем сразу, просто обновляем состояние кнопки
        this.updateMainButtonState()
        // Сбрасываем value инпута, чтобы можно было выбрать тот же файл повторно если удалили
        event.target.value = ""
      }
    },
    removeFile() {
      this.file = null
      this.uploadError = null
      this.importResult = null
      this.updateMainButtonState()
    },
    parseError(error) {
      const responseData = error?.response?.data || error?.data || {}

      // Перевод названий полей на русский
      const fieldTranslations = {
        price: "цены",
        size: "размера",
        count: "количества",
        article: "артикула",
        model: "модели",
        brand: "бренда",
        color: "цвета",
        size_type: "типа размера",
        is_trade: "возможности торга",
        is_custom: "кастомных",
        has_box: "наличия коробки",
      }

      const translateField = (fieldName) => {
        const field = String(fieldName).toLowerCase()
        return fieldTranslations[field] || field
      }

      // Обработка формата с detail.errors (массив ошибок валидации)
      if (
        responseData?.detail?.errors &&
        Array.isArray(responseData.detail.errors)
      ) {
        const errors = responseData.detail.errors

        // Группируем ошибки по строкам
        const errorsByRow = {}
        errors.forEach((err) => {
          const row = err.row_number || err.row || 0
          if (!errorsByRow[row]) {
            errorsByRow[row] = []
          }
          errorsByRow[row].push(err)
        })

        // Формируем сообщения для каждой строки
        const messages = []
        Object.keys(errorsByRow)
          .sort((a, b) => Number(a) - Number(b))
          .forEach((row) => {
            const rowErrors = errorsByRow[row]

            if (rowErrors.length === 1) {
              // Одна ошибка в строке
              const err = rowErrors[0]
              const field = translateField(err.loc || err.field || "")
              const msg = err.msg || ""

              // Если это ошибка "column required" - отсутствует колонка
              if (msg.toLowerCase().includes("column required")) {
                const availableNames = err.available_names || []
                if (availableNames.length > 0) {
                  const suggestedName = availableNames[0]
                  messages.push(
                    `ошибка в ${row} строке отсутствует колонка "${field}". Используйте название "${suggestedName}"`
                  )
                } else {
                  messages.push(
                    `ошибка в ${row} строке отсутствует колонка "${field}"`
                  )
                }
              } else {
                messages.push(`ошибка с полем ${field} в ${row} строке`)
              }
            } else {
              // Несколько ошибок в строке
              // Разделяем ошибки на отсутствующие колонки и обычные ошибки
              const missingColumns = []
              const regularErrors = []

              rowErrors.forEach((err) => {
                const msg = (err.msg || "").toLowerCase()
                const field = translateField(err.loc || err.field || "")

                if (msg.includes("column required")) {
                  const availableNames = err.available_names || []
                  if (availableNames.length > 0) {
                    missingColumns.push(
                      `"${field}" (используйте "${availableNames[0]}")`
                    )
                  } else {
                    missingColumns.push(`"${field}"`)
                  }
                } else {
                  regularErrors.push(field)
                }
              })

              const parts = []
              if (missingColumns.length > 0) {
                if (missingColumns.length === 1) {
                  parts.push(`отсутствует колонка ${missingColumns[0]}`)
                } else {
                  parts.push(`отсутствуют колонки ${missingColumns.join(", ")}`)
                }
              }
              if (regularErrors.length > 0) {
                if (regularErrors.length === 1) {
                  parts.push(`ошибка с полем ${regularErrors[0]}`)
                } else {
                  parts.push(`ошибки с полями ${regularErrors.join(", ")}`)
                }
              }

              if (parts.length > 0) {
                messages.push(`в ${row} строке ${parts.join(", ")}`)
              }
            }
          })

        if (messages.length > 0) {
          return `При загрузке файла возникла ${messages.join(", ")}`
        }
      }

      // Обработка простых массивов строк с ошибками
      const failedRows =
        responseData?.failed_rows ||
        responseData?.rows ||
        responseData?.error_rows ||
        []

      if (Array.isArray(failedRows) && failedRows.length > 0) {
        const rowsStr = failedRows.join(",")
        return `При загрузке строк ${rowsStr} возникла непредвиденная ошибка`
      }

      // Обработка обычного сообщения об ошибке
      const errorMessage = responseData?.message || error?.message || ""

      if (errorMessage) {
        // Ищем паттерн с номерами строк в сообщении
        const rowsMatch = errorMessage.match(/rows?[:\s]+(\d+(?:[,\s]+\d+)*)/i)
        if (rowsMatch && rowsMatch[1]) {
          const rowsStr = rowsMatch[1].replace(/\s+/g, ",")
          return `При загрузке строк ${rowsStr} возникла непредвиденная ошибка`
        }

        // Переводим стандартные сообщения на русский
        const translations = {
          "unexpected error": "непредвиденная ошибка",
          "validation error": "ошибка валидации",
          "file error": "ошибка файла",
          "parse error": "ошибка парсинга",
          "server error": "ошибка сервера",
          "network error": "ошибка сети",
          timeout: "превышено время ожидания",
        }

        let translatedMessage = errorMessage.toLowerCase()
        Object.keys(translations).forEach((key) => {
          translatedMessage = translatedMessage.replace(
            new RegExp(key, "gi"),
            translations[key]
          )
        })

        return `При загрузке файла возникла ${translatedMessage}. Проверьте файл и отправьте повторно`
      }

      // Дефолтное сообщение
      return "При загрузке файла возникла непредвиденная ошибка. Проверьте файл и отправьте повторно"
    },
    async handleUpload() {
      if (!this.file || this.isLoading) return

      // Сбрасываем предыдущие ошибки и результат
      this.uploadError = null
      this.importResult = null
      this.isLoading = true
      this.updateMainButtonState()

      const formData = new FormData()
      formData.append("file", this.file)

      try {
        const response = await this.$store.dispatch("uploadExcelCatalog", formData)
        // data может прийти как response.data (через action) или как сам response
        const result = response?.data || response
        const skipped = Number(result?.skipped || 0)

        if (skipped > 0) {
          // Частичный импорт: остаёмся на странице и показываем, что пропущено.
          // Остальные строки уже импортированы бэкендом.
          this.importResult = {
            created: Number(result?.created || 0),
            updated: Number(result?.updated || 0),
            deleted: Number(result?.deleted || 0),
            skipped,
            skipped_articles: Array.isArray(result?.skipped_articles)
              ? result.skipped_articles
              : [],
          }
          return
        }

        const tg = window.Telegram?.WebApp
        if (tg?.showPopup) {
          tg.showPopup({
            title: "Успешно",
            message: "Каталог загружен",
            buttons: [{ type: "close", text: "Ок" }],
          })
        } else {
          window.alert("Каталог загружен")
        }
        this.$router.go(-1)
      } catch (error) {
        console.error(error)
        // Парсим и переводим ошибку на русский
        this.uploadError = this.parseError(error)
      } finally {
        this.isLoading = false
        this.updateMainButtonState()
      }
    },
    setupMainButton() {
      const tg = window.Telegram?.WebApp
      const mb = tg?.MainButton
      if (!mb) {
        this.hasTelegramMainButton = false
        return
      }
      this.hasTelegramMainButton = true
      this.mainButtonInstance = mb

      if (this.mbHandler) {
        mb.offClick(this.mbHandler)
      }
      this.mbHandler = () => this.handleUpload()
      mb.onClick(this.mbHandler)

      this.updateMainButtonState()
      mb.show()
    },
    updateMainButtonState() {
      const mb = this.mainButtonInstance
      if (!mb) return

      const disabled = !this.file || this.isLoading
      const activeColor = "#e65c00"
      const disabledColor = "#d7d8dd"

      if (this.isLoading) {
        // Показываем индикатор загрузки
        mb.setText("Загрузка...")
        if (mb.showProgress) {
          mb.showProgress()
        }
        mb.disable()
        mb.color = disabledColor
        mb.textColor = "#9b9b9b"
      } else if (disabled) {
        mb.setText("Загрузить")
        if (mb.hideProgress) {
          mb.hideProgress()
        }
        mb.disable()
        mb.color = disabledColor
        mb.textColor = "#9b9b9b"
      } else {
        mb.setText("Загрузить")
        if (mb.hideProgress) {
          mb.hideProgress()
        }
        mb.enable()
        mb.color = activeColor
        mb.textColor = "#ffffff"
      }
    },
    destroyMainButton() {
      const mb = this.mainButtonInstance
      if (mb && this.mbHandler) {
        mb.offClick(this.mbHandler)
      }
      if (mb) {
        mb.hide()
      }
      this.mbHandler = null
      this.mainButtonInstance = null
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 2rem 1rem;
  min-height: 100vh;
  display: flex;
  background-color: #efeff4;
  flex-direction: column;
  gap: 3rem;
  text-align: center;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.stepTitle {
  font-size: 1.375rem;
  font-weight: 700;
  color: #000;
}

.stepDesc {
  font-size: 1rem;
  color: #3a3a3c;
  line-height: 1.4;
  max-width: 22.5rem;
  margin-bottom: 1rem;
}

.downloadBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #3a834a; /* Green color from screenshot */
  color: #fff;
  padding: 0.75rem 0;
  border-radius: 0.625rem;
  text-decoration: none;
  font-weight: 500;
  font-size: 1rem;
  width: 100%;
  box-shadow: 0 4px 12px rgba(58, 131, 74, 0.2);
}

.uploadBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #000;
  color: #fff;
  padding: 0.75rem 0;
  border-radius: 0.625rem;
  border: none;
  font-weight: 500;
  font-size: 1rem;
  width: 100%;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.uploadContainer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.filePreview {
  width: -webkit-fill-available;
  background: #fff;
  border-radius: 0.625rem;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 0.75rem;
}

.fileInfo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  overflow: hidden;
}

.fileName {
  font-size: 0.9rem;
  font-weight: 500;
  color: #000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fileIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.fileIcon svg {
  width: 100%;
  height: 100%;
}

.removeBtn {
  background: none;
  border: none;
  padding: 0;
  width: 1.25rem;
  height: 1.25rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.removeBtn img {
  width: 100%;
  height: 100%;
}

.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hiddenInput {
  display: none;
}

.submitBar {
  margin-top: auto;
  padding-top: 2rem;
}

.submitBtn {
  width: 100%;
  padding: 1rem;
  border-radius: 1rem;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  background: #e6e6e6;
  color: #9b9b9b;
  cursor: not-allowed;
}

.submitBtn:not(:disabled) {
  background: #e65c00;
  color: #fff;
  cursor: pointer;
}

.submitBtn:disabled {
  opacity: 0.7;
}

.submitBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner {
  width: 1rem;
  height: 1rem;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.errorBox {
  background: #ffffff;
  border-radius: 0.625rem;
  padding: 1rem;
  text-align: center;
}

.errorTitle {
  font-size: 1rem;
  font-weight: 700;
  color: #000;
  margin: 0 0 0.5rem 0;
}

.errorMessage {
  font-size: 0.875rem;
  color: #3a3a3c;
  margin: 0;
  line-height: 1.4;
}

.resultBox {
  background: #ffffff;
  border-radius: 0.625rem;
  /* Акцентный бордер в фирменном цвете (#e65c00), как в submitBtn и MainButton */
  border: 1px solid rgba(230, 92, 0, 0.25);
  border-left: 0.25rem solid #e65c00;
  padding: 1rem;
  text-align: left;
}

.resultTitle {
  font-size: 1rem;
  font-weight: 700;
  color: #e65c00;
  margin: 0 0 0.5rem 0;
}

.resultSummary {
  font-size: 0.875rem;
  color: #3a3a3c;
  margin: 0 0 0.5rem 0;
  line-height: 1.4;
}

.resultSkipped {
  font-size: 0.8125rem;
  color: #3a3a3c;
  margin: 0 0 0.25rem 0;
  line-height: 1.4;
}

.resultArticles {
  font-size: 0.8125rem;
  color: #000;
  margin: 0;
  line-height: 1.4;
  word-break: break-word;
}

.resultHint {
  font-size: 0.8125rem;
  color: #3a3a3c;
  margin: 0.75rem 0 0 0;
  line-height: 1.4;
}
</style>
